import Components from "app/components";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";

export function RegistrationJSHIR() {
  const auth = Components.section.auth.jshirregister
  return (
    <Routes>
      <Route
        element={
          <>
            <Outlet />
          </>
        }
      >
        <Route path="info" element={<auth.Info />} />
        <Route path="number-confirm" element={<auth.ConfirmNumber />} />
        <Route
          index
          element={<Navigate to={"/auth/jshir-register/info"} />}
        />
      </Route>
    </Routes>
  );
}
